import { useContext, useEffect, useRef } from 'react';
import { ScriptLoaderContext } from '../../utils/ScriptLoaderProvider';

interface GeoCoder {
  addressSearch: (address: string, callback: (result: AddressSearchResult[], status: any) => void) => void;
  coord2Address: (x: number, y: number, callback: (result: Coord2AddressResult[], status: any) => void) => void;
}

export interface Coord2AddressResult {
  road_address: { address_name: string };
  address: { address_name: string };
}

export interface AddressSearchResult {
  address: {
    x: string;
    y: string;
    address_name: string;
  };
  road_address?: {
    address_name: string;
  };
}

export const useKakaoGeocoder = () => {
  const { kakaoLoaded } = useContext(ScriptLoaderContext);
  const geoCoder = useRef<GeoCoder>();

  useEffect(() => {
    if (kakaoLoaded) geoCoder.current = new window.kakao!.maps.services.Geocoder();
  }, [kakaoLoaded]);

  return geoCoder;
};
